<script setup>
import { storeToRefs } from 'pinia';

// // Store management imports
// import { useBreakStore } from '@/stores/break';
import { useDirectionStore } from '@/stores/direction';
// import { useGeneralStore } from '@/stores/general';

// // Module imports
// import TvPLinkerButton from '@/views/TvPlusLinker/TvPLinkerButton.vue';
import SimpleWatchNow from '@/views/TvPlusLinker/SimpleWatchNow.vue';

const { directionModule } = storeToRefs(useDirectionStore());

// // SamsungShopping functions

const callDirectionModule = () => {
  return directionModule.value;
};
</script>

<template>
  <main class="samsung-shopping">
    <div class="samsung-shopping__container">
      <SimpleWatchNow v-if="callDirectionModule() === 'SimpleWatchNow'" />
    </div>
  </main>
</template>

<style lang="scss">
@use './tvpluslinker.scss';
</style>
